import { inject, Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { ENVIRONMENT } from '@controladad/ng-base';
import { map } from 'rxjs';

export type FileType = 'Product' | 'Banner' | 'Blog' | 'Category';
export type UploadResult = { path: string; url: string };

@Injectable({
  providedIn: 'root',
})
export class AttachmentApiService extends BaseApi<any> {
  private readonly environment = inject(ENVIRONMENT);
  constructor() {
    super('');
  }

  upload(file: File, type: FileType = 'Product') {
    const form = new FormData();
    form.set('File', file);
    form.set('Type', type);

    return http$
      .post<{ paths: UploadResult }>(`${this.environment.apiBaseUrl}/AdminPanel/UploadFile`, form)
      .pipe(map((i) => i.paths));
  }
}
